export default __webpack_public_path__ + "static/mefa-shop_1_1_en-ef9a9a5e58e7b3abcee0b317dfa69603.png";